import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";

export const AuxiliaresItemSchema = z.object({
  code: z.string().min(1, { message: REQUIRED_FIELD }),
  name: z.string().min(1, { message: REQUIRED_FIELD }),
});

export const ItemSchemaForProvince = z.object({
  code: z.string().min(1, { message: REQUIRED_FIELD }),
  name: z.string().min(1, { message: REQUIRED_FIELD }),
});

export const ItemSchemaForCounty = z.object({
  code: z.string().min(1, { message: REQUIRED_FIELD }),
  name: z.string().min(1, { message: REQUIRED_FIELD }),
  province: z.object({
    id: z.number(),
    name: z.string().min(1, { message: REQUIRED_FIELD }),
    code: z.string().min(1, { message: REQUIRED_FIELD }),
    isActive: z.boolean(),
  }),
});
